import { atom } from "jotai";

/** Виртуальная группа «Все товары» */
export const ALL_ITEMS_GROUP = {
  itemgroupid: "0",
  name: "Все товары",
  parentid: "0",
  avaliable: 1,
  onlywhole: 1,
  importcode: "0",
  position: 0,
  groupid: "0",
};

export const activeItemsGroupAtom = atom(ALL_ITEMS_GROUP);
export const selectedProductAtom = atom(null);
